import React from 'react';
import PageContentNav from './PageContentNav';
import ContentArea from '../../../cmp/content/ContentArea';
type Param = {
    nextBtnDisabled?: boolean,
    nextBtnVisible?: boolean,
    backBtnVisible?: boolean
}

const PageContentArea: React.FC<Param> = ({ nextBtnDisabled, nextBtnVisible, backBtnVisible, children }) => {
    return (
        <ContentArea>
            {children}
            <div style={{ marginTop: 30 }}>
                <PageContentNav nextBtnDisabled={nextBtnDisabled} nextBtnVisible={nextBtnVisible} backBtnVisible={backBtnVisible} />
            </div>
        </ContentArea>);
}

export default PageContentArea;